export default __webpack_public_path__ + "static/placeholder-style0-4-3-portrait-5deb5bdca172ea1abb50214059a2d685.png";